import styled from '@emotion/styled';
import { Grid } from '@mui/material';
import { Colors } from '../../../colors';

export const ListAttendeesPageStyle = {
  Container: styled(Grid)<any>`
    width: 100%;
    background: ${Colors.PrimaryBackground};
    padding-left: 42px;
    padding-right: 42px;
  `,
  ListContainer: styled.div`
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    background: whitesmoke;
    border-radius: 4px;
    border-collapse: separate;
  `,
  ContainerBack: styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 26px;
    cursor: pointer;
    padding-top: 35px;
  `,
  BackTitle: styled.p`
    color: ${Colors.White};
    font-family: EncodeSans-Medium;
    font-size: 14px;
    margin-left: 10px;
  `,
  TitleContainer: styled.div`
    display: flex;
    flex-grow: 1;
    border-radius: 4px;
    border-collapse: separate;
    justify-content: space-between;
  `,
  TitleChipContainer: styled.div`
    display: flex;
    align-items: center;
  `,
  ContainerUploadCsv:  styled.div`
    display: flex;
    cursor: pointer
  `,
  TitleUploadCsv: styled.p`
    color: ${Colors.White};
    font-family: EncodeSans-SemiBold;
    font-size: 14px;
    text-decoration: underline;
    margin-left: 10px
  `,
  TitlePage: styled.p`
    color: ${Colors.White};
    font-family: EncodeSans-SemiBold;
    font-size: 16px;
    margin-right: 25px
  `,
  SubtitlePage: styled.p`
    margin-top: 5px;
    color: ${Colors.White};
    font-family: EncodeSans-Medium;
    font-size: 12px;
    margin-bottom: 24px;
  `,
  TitleAttendees: styled.p`
    color: ${Colors.White};
    font-family: EncodeSans-Regular;
    font-size: 16px;
    margin-bottom: 10px;
  `,
  Attendees: styled.span`
    color: ${Colors.White};
    font-family: EncodeSans-SemiBold;
    font-size: 16px;
  `,
  ContainerAttendees: styled.div`
    margin-bottom: 16px
  `,
  ContainerInfo: styled.div`
    display: flex;
  `,
  ContainerTooltip: styled.div`
    margin-left: 10px;
  `,
  TitleTooltip: styled.span<any>`
    font-family: EncodeSans-Medium;
    font-size: 12px;
    color: ${Colors.Black};
    margin-bottom: 5px;
  `,
  Tooltip: styled.div<any>`
    background-color: ${Colors.White};
  `,
  ContainerDuplicateAttendees: styled.div`
    display: flex; 
    align-items: center; 
    justify-content: flex-end;
  `,
  TextDuplicateAttendees: styled.p`
    font-family: EncodeSans-Bold;
    font-size: 12px;
    color: ${Colors.Black};
    margin-left: 5px;
  `,
  TextAttention: styled.span`
    font-family: EncodeSans-Bold;
    font-size: 12px;
    color: ${Colors.Black}
  `,
};
